import React from 'react'
import { useState } from 'react'
import { CBMessagePreview, CBMessageFeedPreview, CBInstitutionPreview, CBCollegeListPreview, CBContentPreviewsModal, CBSavedListPreview } from 'cb-message-builder'
import { examplePages } from './AppData'
import { v4 as uuid } from 'uuid';
import 'cb-message-builder/dist/index.css'

const App = () => {
    const page      = examplePages[0]
    const pageTwo   = examplePages[1]
    const pageThree = examplePages[2]

    const [showPreviewModal, setShowPreviewModal] = React.useState(false)

    // CBMessagePreview can be passed a preferred width for the preview element.
    const width = 120

    /**
     * Data setup for non-message previews
     */
    const universityName     = 'University of Virginia'
    const universityLocation = 'Charlottesville, Virginia'
    const squareLogo         = "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/UVA%20-%20Logo%20-%20Square%20-%20Large.png?alt=media&token=8eed43e1-e049-4827-aff9-36de97543ee7"
    const wordmarkLogo       = "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/UVA%20-%20Logo%20-%20Light%20-%20Large.png?alt=media&token=135f7557-bc65-4ce4-a0b5-aba0c1ed9a02"
    const institutionImage   = "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/UVA%20%20-%20Header%20Image%20-%20Large.jpg?alt=media&token=49e2de83-2926-4f46-8fed-148bc104f951"
    const collegeData = [
        {
            title : universityName, 
            subtitle: universityLocation,
            logo: squareLogo,
            logoDescription: 'Logo - Square Avatar',
            background: institutionImage,
            backgroundDescription: 'Organization Image',
            //ariaHidden: ['title', 'subtitle', 'logo', 'background']
        } ,

        {
            title : 'Lorem Ipsum', 
            subtitle: 'Someplace, Somewhere',
            ariaHidden: ['title', 'subtitle']
        } ,

        {
            title : 'Lorem Ipsum', 
            subtitle: 'Someplace, Somewhere',
            ariaHidden: ['title', 'subtitle']
        }             
        
    ]

    const messageData = [
        {     title: "ABCD Lorem ipsum dolor sit amet, consectetur.", 
              caption: 'AUG 7',
              logo: wordmarkLogo, 
              logoDescription: 'Logo - wordmark (or square avatar if wordmark not provided)',
              logoAvatar: squareLogo,
              logoType: 'wordmark', // 'wordmark' or 'avatar'
              image: "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-9176819c-7e4a-40db-bee0-2272ff2194d5-UCLA%20-%20Message%201%20-%20Large.jpg?alt=media&token=8a1cf387-6cd2-4e3a-be17-4a2bb4a77460",
              imageDescription: null,
            },
            { title: "Lorem ipsum dolor sit amet, consectetur.", caption: 'AUG 8', ariaHidden: ['title', 'logo', 'date', 'image'] },
            { title: "Lorem ipsum dolor sit amet, consectetur.", caption: 'AUG 9', ariaHidden: ['title', 'logo', 'date', 'image'] },
            { title: "Lorem ipsum dolor sit amet, consectetur.", caption: 'AUG 10',ariaHidden: ['title', 'logo', 'date', 'image'], image: "https://secure-media.collegeboard.org/social-media/CB_og-image_v1.png"  },
            { title: '', ariaHidden: ['title', 'logo', 'date', 'image'] },
            { title: '', ariaHidden: ['title', 'logo', 'date', 'image'] },
            { title: '', ariaHidden: ['title', 'logo', 'date', 'image'] },
    ]
        
    /**
     * Message Preview
     */
    const messagePreview = <CBMessagePreview name="Message" 
                                             width={width}
                                             title="Some Message"
                                             caption="AUG 12"
                                             institutionTitle="Institution"
                                             institutionLocation="Somewhere"
                                             institutionLogo="https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/UVA%20-%20Logo%20-%20Square%20-%20Large.png?alt=media&token=8eed43e1-e049-4827-aff9-36de97543ee7"
                                             image="https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-2b909c93-3c7b-44ca-99dd-5f7a841e95c4-UCLA%20-%20Message%202%20-%20Large.jpg?alt=media&token=f85804a3-a141-4849-a582-cfbc7734d34f"
                                             institutionImage=""
                                             institutionPreview=""
                                             imageDescription="Message Image - Doctor performing resuscitation"
                                             //ariaHidden={['title', 'caption', 'image', 'institutionTitle', 'institutionLocation', 'institutionLogo', 'body']}
                                             />                    

    /**
     * The feed preview will display the relevant content from the 'page' property it's passed
     * But also takes properties for the additional things it displays that isnt defined by whats in a message.
     */
    const feedPreview = (<CBMessageFeedPreview 
                                name={"Feed"}
                                title={"Messages"}
                                messages={messageData}
                                width={width}
                                //ariaHidden={['title', 'subtitle']}
                            />
    )


    /**
     * Institution Profile Preview
     * Takes arguments for the title,subtitle,description,logo, and background
     */
    const institutionPreview = (
        <CBInstitutionPreview 
            name="Institution Preview"
            width={width}
            title={universityName}
            titleDescription={"Organization Name"}
            subtitle={universityLocation}
            subtitleDescription={"City, State"}
            description="'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. et dolore magna aliqua. et dolore magna aliqua."
            logo={squareLogo}
            logoDescription={"Square Logo"}
            background={institutionImage}
            backgroundDescription={"Background Image"}
            //ariaHidden={['title', 'subtitle', 'description', 'backgroundImage', 'logo', 'messagesHeader', 'messagesSubtitle']}
            />
    )

    /**
     * College List Preview 
     * Takes an argument for:
     * - the tiles to show.
     * - the list items to show.
     */
    const collegeListPreview = (
        <CBCollegeListPreview 
            name="College List"
            title="Colleges"
            width={width}
            tileItems={collegeData}
            listItems={collegeData}
            //ariaHidden={['title', 'tilesHeader', 'tilesSubheader', 'listHeader']}
            ></CBCollegeListPreview>
    )

    const savedListPreview = (
        <CBSavedListPreview
            name="Saved"
            title="Saved"
            width={width}
            tileItems={collegeData}
            //ariaHidden={['title', 'tilesHeader', 'tilesSubheader', 'listHeader']}
            listItems={messageData}></CBSavedListPreview>
    )


    // Show a grid of previews
    return (
        <div className="preview-page">
            <h1>Preview Modal</h1>
            <div>
                <a href="#" onClick={() => {setShowPreviewModal(true)}}>Show Preview Modal</a>
                <CBContentPreviewsModal show={showPreviewModal} onClose={setShowPreviewModal}>
                    {messagePreview}
                    {feedPreview}                   
                    {collegeListPreview}
                    {savedListPreview}
                    {institutionPreview}
                </CBContentPreviewsModal>                        
            </div>

            <h1>Preview Types</h1>
            <div className="preview-grid polymer-grid polymer-grid-4-columns">
                <ExpandableMessagePreview>
                    {feedPreview}
                </ExpandableMessagePreview>

                <ExpandableMessagePreview>
                    {messagePreview}
                </ExpandableMessagePreview>

                <ExpandableMessagePreview>
                    {institutionPreview}
                </ExpandableMessagePreview>

                <ExpandableMessagePreview>
                    {savedListPreview}
                </ExpandableMessagePreview>

                <ExpandableMessagePreview>
                    {collegeListPreview}
                </ExpandableMessagePreview>

            </div>

            <h1>Lots of Previews</h1>
            <div className="preview-grid polymer-grid polymer-grid-4-columns">
                <CBMessagePreview page={pageTwo}   width={width}/>
                <CBMessagePreview page={pageThree} width={width}/>
                <CBMessagePreview page={page}      width={width}/>
                <CBMessagePreview page={pageTwo}   width={width}/>
                <CBMessagePreview page={pageThree} width={width}/>
                <CBMessagePreview page={page}      width={width}/>
                <CBMessagePreview page={pageTwo}   width={width}/>
                <CBMessagePreview page={pageThree} width={width}/>
                <CBMessagePreview page={page}      width={width}/>
                <CBMessagePreview page={pageTwo}   width={width}/>
                <CBMessagePreview page={pageThree} width={width}/>
                <CBMessagePreview page={page}      width={width}/>
                <CBMessagePreview page={pageTwo}   width={width}/>
                <CBMessagePreview page={pageThree} width={width}/>
                <CBMessagePreview page={page}      width={width}/>
            </div>
        </div>
    )
}

/**
 * Example of how to show a preview fullscreen when clicking on it
 */
function ExpandableMessagePreview({ children }) {
    const [expand, setExpand] = React.useState(false)
    return <div style={{ cursor : 'pointer'}}>
            <CBContentPreviewsModal show={expand} onClose={() => {setExpand(false)}}>
                {children}
            </CBContentPreviewsModal>
            <div onClick={() => {setExpand(true)}} >
                {children}
            </div>
        </div>
}

export default App
